export function hasRoles(userRoles, rolesString) {
    const roles = rolesString.split(';')
    var hasPermission = false
    roles.forEach(role => {
        if (userRoles.includes(role)) {
            hasPermission = true
        }
    })
    return hasPermission
}